<template>
  <div>
    <accounts-loader
      :account-type="accountType"
      @loaded="onLoaded"
    />
    <q-table
      :columns="columns"
      :rows="filteredAccounts"
      v-model:pagination="pagination"
      :loading="isLoading"
      wrap-cells
      @request="pagination = $event.pagination"
    >
      <template v-slot:body-cell-name="props">
        <q-td :props="props">
          <router-link :to="`/admin/accounts/${props.row.id}/users`">
            {{ props.value }}
          </router-link>
        </q-td>
      </template>
      <template v-slot:body-cell-location="props">
        <q-td :props="props">
          <location :location="props.value" />
        </q-td>
      </template>
      <template v-slot:body-cell-freeTrials="props">
        <q-td :props="props">
          <free-trials-editor
            :account-id="props.row.id"
            :value="props.value"
            @updated="onAccountTrialsUpdated(props.row.id, $event)"
          />
        </q-td>
      </template>
      <template v-slot:body-cell-createdAt="props">
        <q-td :props="props">
          <humanize-time :time="props.value" />
        </q-td>
      </template>
    </q-table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { QTablePagination } from '@/type';
import HumanizeTime from '@/components/HumanizeTime.vue';
import AccountsLoader from '@/iam/account/AccountsLoader.vue';
import FreeTrialsEditor from '@/iam/account/FreeTrialsEditor.vue';
import { Account } from '@/iam/types';
import { HasTaskMixin } from '@/mixins';
import Location from '@/iam/location/Location.vue';

interface Data {
  pagination: QTablePagination,
  accounts: Account[]
  task: Promise<Account[]>|null,
  columns: object[],
}

export default defineComponent({
  mixins: [HasTaskMixin],
  components: {
    AccountsLoader,
    HumanizeTime,
    Location,
    FreeTrialsEditor,
  },
  props: {
    accountType: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
      },
      accounts: [],
      task: null,
      columns: [
        {
          name: 'name',
          label: 'Name',
          field: 'name',
          align: 'left',
        },
        {
          name: 'location',
          label: 'Location',
          field: 'location',
          align: 'left',
        },
        {
          name: 'phoneNo',
          label: 'Phone No.',
          field: 'phoneNumber',
          align: 'left',
        },
        {
          name: 'freeTrials',
          label: 'Free Trials',
          field: 'numFreeTrials',
          align: 'left',
        },
        {
          name: 'createdAt',
          label: 'Created',
          field: 'createdAt',
          align: 'left',
        },
      ],
    };
  },
  computed: {
    filteredAccounts(): Account[] {
      const offset = (this.pagination.page - 1) * this.pagination.rowsPerPage;
      return this.accounts.slice(offset, offset + this.pagination.rowsPerPage);
    },
  },
  methods: {
    onLoaded(accounts: Account[]) {
      this.accounts = accounts;
      this.pagination = {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: accounts.length,
      };
    },
    onAccountTrialsUpdated(accoutnId: number, trials: number) {
      const index = this.accounts.findIndex(a => a.id === accoutnId);
      if (index !== -1) {
        const updatedAccount = { ...this.accounts[index], numFreeTrials: trials };
        this.accounts.splice(index, 1, updatedAccount);
      }
    },
  },
});
</script>
